import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetBasicPayroll } from '../../redux/payroll/hook';
import { PAGINATION_DEFAULT, basicStatusConfig } from '../../utils/constants';
import DataTable from '../datatable';

export const BasicPayrollTab = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  });

  const { data: basicPayroll } = useGetBasicPayroll(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search,
  );

  useEffect(() => {
    console.log(basicPayroll, '= basic');
  }, [basicPayroll]);

  const history = useHistory();

  function Continue(id, type) {
    let index = basicPayroll.data.findIndex((item) => item.id === id);
    if (index !== -1) {
      if (type === 'preview') {
        history.push(`/payroll/basic/preview/${basicPayroll.data[index].ref}`);
      } else if (type === 'view') {
        history.push(`/payroll/basic/view/${basicPayroll.data[index].ref}`);
      }
    }
  }

  const statusConfig = [
    {
      label: 'In Progress',
      color: 'orange',
      value: 0,
    },
    {
      label: 'Completed',
      color: 'green',
      value: 1,
    },
    
  ];

  const tableConfig = {
    headers: ['Date', 'Ref. Number', 'Description', 'Month', 'Status'],
    keys: ['created', 'ref', 'desc', 'month', 'status'],
    mobileHeader: {
      left: {
        title: 'Date',
        key: 'created',
      },
      right: {
        title: 'Description',
        key: 'desc',
      },
    },
  };

  const actionConfig = [
    {
      name: 'Continue',
      color: 'green',
      action: (id) => {
        Continue(id, 'preview');
      },
    },
    {
      name: 'View',
      color: 'green',
      action: (id) => {
        Continue(id, 'view');
      },
    },
    {
      name: 'Delete',
      color: 'red',
      action: (id) => {
        Continue(id, 'delete');
      },
    },
    
  ];

  return (
    <div className='flex flex-col bg-white'>
      <div className='flex flex-col'>
        <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
          <div className='p3-bold header-4'>
            Basic Payroll Summary
          </div>
        </div>
        <hr className='divider mt-2 mb-2' />
        <DataTable
          data={basicPayroll}
          tableConfig={tableConfig}
          statusConfig={statusConfig}
          actionConfig={actionConfig}
          updatePagination={(data) => setPagination(data)}
          filterByStatus={basicStatusConfig}
          searchData={true}
          computedActions={true}
        />
      </div>
    </div>
  );
};
